import React, { FC } from "react";
import { Image } from "../image";
import type { PaymentChannelsHeroProps } from "@/types";
import { TextCols } from "../text-cols";

export const PaymentChannelsHero: FC<PaymentChannelsHeroProps> = ({
  label,
  title,
  description,
  cover,
}) => {
  return (
    <section className="paymentChannelsHero">
      <div className="wrapper">
        <TextCols
          headingLevel="h1"
          size="lg"
          label={label}
          content={{
            title,
            textCol1: description.textCol1,
            textCol2: description.textCol2,
          }}
          maxTitleWidth={937}
        />
      </div>
      <div className="wrapper wrapper_lg">
        {cover.file?.url && (
          <Image
            className="paymentChannelsHero--cover"
            src={cover as any}
            alt={cover.title}
            animateInView
          />
        )}
      </div>
    </section>
  );
};
